import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
export default class CpdMessage extends Component {
    render() {
        const { message, handleScrollToLine } = this.props;
        const file = message.match(/is too similar to (?<filePath>.*:[0-9]+)/);
        if (!file || file.length === 1 || !file.groups) {
            return message;
        }
        const filePath = file.groups.filePath;
        return (_jsxs(_Fragment, { children: [message.replace(filePath, ''), _jsx("a", { href: `#${filePath}`, onClick: (event) => handleScrollToLine(event, filePath), children: filePath })] }));
    }
}
